module.exports = __webpack_public_path__ + "img/wait_payment.911f8178.svg";